export default __webpack_public_path__ + "static/media/mysql.7b4acaff.png";